<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-2">
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name" bindValue="apptid"
						[clearable]="true" [multiple]="false" id="company" formControlName="company"
						placeholder="Company*"
						(change)="getVesselListByCompany(true);refreshTable();showHideNoOfCandidates();"
						[appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('company')" class="text-danger">
						<span *ngIf="f.company.errors?.required">
							Required
						</span>
						<span *ngIf="f.company.errors?.incorrect">
							{{customError.company}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('invoice_no')}" id="invoice_no"
							formControlName="invoice_no" placeholder="Invoice No*">
						<label for="invoice_no">Invoice No.*</label>
					</div>
					<p *ngIf="showError('invoice_no')" class="text-danger">
						<span *ngIf="f.invoice_no.errors?.required">
							Required
						</span>
						<span *ngIf="f.invoice_no.errors?.incorrect">
							{{customError.invoice_no}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>From</mat-label>
						<input matInput [matDatepicker]="from_picker_template" formControlName="fromDate"
							(change)="refreshTable()">
						<mat-hint>MM/DD/YYYY</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="from_picker_template"></mat-datepicker-toggle>
						<mat-datepicker #from_picker_template (closed)="refreshTable()"></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('fromDate')" class="text-danger">
						<span *ngIf="f.fromDate.errors?.required">
							Required
						</span>
						<span *ngIf="f.fromDate.errors?.incorrect">
							{{customError.fromDate}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>To</mat-label>
						<input matInput [matDatepicker]="to_picker_template" formControlName="toDate"
							(change)="refreshTable()">
						<mat-hint>MM/DD/YYYY</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="to_picker_template"></mat-datepicker-toggle>
						<mat-datepicker #to_picker_template (closed)="refreshTable()"></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('toDate')" class="text-danger">
						<span *ngIf="f.toDate.errors?.required">
							Required
						</span>
						<span *ngIf="f.toDate.errors?.incorrect">
							{{customError.toDate}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>Invoice Date</mat-label>
						<input matInput [matDatepicker]="invoice_no_picker_template" formControlName="invoice_date"
							(dateChange)="invoiceDateChanged()">
						<mat-datepicker-toggle matIconSuffix [for]="invoice_no_picker_template"></mat-datepicker-toggle>
						<mat-datepicker #invoice_no_picker_template></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('invoice_date')" class="text-danger">
						<span *ngIf="f.invoice_date.errors?.required">
							Required
						</span>
						<span *ngIf="f.invoice_date.errors?.incorrect">
							{{customError.invoice_date}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<mat-form-field appearance="outline">
						<mat-label>Due Date</mat-label>
						<input matInput [matDatepicker]="due_date_picker_template" formControlName="due_date">
						<mat-datepicker-toggle matIconSuffix [for]="due_date_picker_template"></mat-datepicker-toggle>
						<mat-datepicker #due_date_picker_template></mat-datepicker>
					</mat-form-field>
					<p *ngIf="showError('due_date')" class="text-danger">
						<span *ngIf="f.due_date.errors?.required">
							Required
						</span>
						<span *ngIf="f.due_date.errors?.incorrect">
							{{customError.due_date}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('test_fee')}" id="test_fee"
							formControlName="test_fee" placeholder="Test Fees*" (keyup)="getAmount();">
						<label for="test_fee">Test Fees*</label>
					</div>
					<p *ngIf="showError('test_fee')" class="text-danger">
						<span *ngIf="f.test_fee.errors?.required">
							Required
						</span>
						<span *ngIf="f.test_fee.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.test_fee.errors?.incorrect">
							{{customError.test_fee}}
						</span>
					</p>
				</div>
				<div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="currencyList" bindLabel="name" bindValue="nid"
						[clearable]="true" [multiple]="false" id="currency" formControlName="currency"
						placeholder="Currency*" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('currency')" class="text-danger">
						<span *ngIf="f.currency.errors?.required">
							Required
						</span>
						<span *ngIf="f.currency.errors?.incorrect">
							{{customError.currency}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('amount')}" id="amount"
							formControlName="amount" placeholder="Amount*">
						<label for="amount">Amount*</label>
					</div>
					<p *ngIf="showError('amount')" class="text-danger">
						<span *ngIf="f.amount.errors?.required">
							Required
						</span>
						<span *ngIf="f.amount.errors?.incorrect">
							{{customError.amount}}
						</span>
					</p>
				</div>
				<!-- <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="branchList" bindLabel="name" bindValue="id" [clearable]="true"
						[multiple]="false" id="branch" formControlName="branch" placeholder="Branch"
						(change)="refreshTable();" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('branch')" class="text-danger">
						<span *ngIf="f.branch.errors?.required">
							Required
						</span>
						<span *ngIf="f.branch.errors?.incorrect">
							{{customError.branch}}
						</span>
					</p>
				</div> -->
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="vesselList" bindLabel="vessel" bindValue="id" [clearable]="true"
						[multiple]="false" id="vessel" formControlName="vessel" placeholder="Vessel"
						(change)="refreshTable();" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('vessel')" class="text-danger">
						<span *ngIf="f.vessel.errors?.required">
							Required
						</span>
						<span *ngIf="f.vessel.errors?.incorrect">
							{{customError.vessel}}
						</span>
					</p>
				</div>
				<!-- <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="pay_mod_list" bindLabel="pay_mod" bindValue="id"
						[clearable]="true" [multiple]="true" id="pay_mod" formControlName="pay_mod"
						placeholder="Payment Mode" (change)="refreshTable();" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('pay_mod')" class="text-danger">
						<span *ngIf="f.pay_mod.errors?.required">
							Required
						</span>
						<span *ngIf="f.pay_mod.errors?.incorrect">
							{{customError.pay_mod}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="paymentList" bindLabel="name" bindValue="name"
						[clearable]="true" [multiple]="true" id="payment" formControlName="payment"
						placeholder="Payment Status" (change)="refreshTable();" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('payment')" class="text-danger">
						<span *ngIf="f.payment.errors?.required">
							Required
						</span>
						<span *ngIf="f.payment.errors?.incorrect">
							{{customError.payment}}
						</span>
					</p>
				</div> -->
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="unique_all" bindLabel="name" bindValue="val" [clearable]="false"
						[multiple]="false" id="unique" formControlName="unique" placeholder="Unique/All"
						(change)="refreshTable();" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('unique')" class="text-danger">
						<span *ngIf="f.unique.errors?.required">
							Required
						</span>
						<span *ngIf="f.unique.errors?.incorrect">
							{{customError.unique}}
						</span>
					</p>
				</div>
				<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12" [hidden]="!showNoOfCandidates">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('number_of_vessel')}"
							id="number_of_vessel" formControlName="number_of_vessel" placeholder="Candidates Count*"
							(keyup)="getAmount();">
						<label for="number_of_vessel">Candidates Count*</label>
					</div>
					<p *ngIf="showError('number_of_vessel')" class="text-danger">
						<span *ngIf="f.number_of_vessel.errors?.required">
							Required
						</span>
						<span *ngIf="f.number_of_vessel.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.number_of_vessel.errors?.incorrect">
							{{customError.number_of_vessel}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col-md-12">
					<div class="table-responsive" [hidden]="showNoOfCandidates">
						<table *ngIf="dtOptions.pagingType" datatable [dtOptions]="dtOptions"
							class="table table-striped table-bordered table-hover" style="width: 100%;">
							<thead>
								<tr class="table_head">
									<th style="width: 5% !important;">
										<mat-checkbox [(ngModel)]="checkAll" [ngModelOptions]="{standalone: true}"
											(change)="checkUncheckAll(checkAll)" matTooltip="Select All"
											[color]="'primary'"></mat-checkbox>
									</th>
									<th style="width: 30% !important;">Company</th>
									<th style="width: 25% !important;">Profile</th>
									<th style="width: 10% !important;">DOE</th>
									<th style="width: 20% !important;">Ref. No.</th>
									<th style="width: 10% !important;">Participants</th>
								</tr>
							</thead>
							<tbody *ngIf="dataList?.length != 0">
								<tr *ngFor="let v of dataList;let i = index;">
									<td>
										<mat-checkbox [(ngModel)]="v.checked" [ngModelOptions]="{standalone: true}"
											(change)="apptSelected(v.appt_list,v.ref_no,v.checked)" matTooltip="Select"
											[color]="'primary'"></mat-checkbox>
									</td>
									<td>{{ v.company }}</td>
									<td>{{ v.profile }}</td>
									<td>{{ v["DOE"] }}</td>
									<td>{{ v.ref_no }}</td>
									<td>{{ v.numberOfCandidate || v.appt_list.length }}</td>
								</tr>
							</tbody>
							<tbody *ngIf="dataList?.length == 0">
								<tr>
									<td colspan="6" class="text-center">No data found!</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/invoice-list']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>